<template>
  <div class="set-product">
    <div class="product-inputs">
          <ElementSelect
            :label="$t('allDomain.group')"
            heightis40
            :options="userSelectsOptions"
          />
       <loginInput
         :label="`${$t('allDomain.originBroadband')}(MB/${$t('allDomain.second')})`"
         placeholder=""
         inputStyle="width: 567px;height: 40px; margin-left: 28px;"
         realInputStyle="width: 567px;height: 40px;"
        />

       <loginInput
         :label="$t('allDomain.longLink')"
         :placeholder="$t('allDomain.linkTip')"
         inputStyle="width: 567px;height: 40px; margin-top: 44px;"
         realInputStyle="width: 567px;height: 40px;"
        />
    </div>

          <!--  -->
        <div class="btn-content">
            <div @click="commitclick">{{$t('product.commit')}}</div>
        </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      createDate: '',
      userSelectsOptions: [
        {
          label: 'tt001@qq.com',
          value: '1',
        },
        {
          label: 'tt002@qq.com',
          value: '2',
        },
      ],
    };
  },
  methods: {
    commitclick() {},
  },
};
</script>

<style lang="scss" scoped>
  .product-inputs {
    display: flex;
    flex-wrap: wrap;
    margin-top: 28px;
    margin-bottom: 36px;
  }

        .btn-content {
            width: 100%;
            margin-top: 66px;
            :first-child {
                width: 223px;
                height: 44px;
                background: #336DFF;
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FFFFFF;
                margin: 0 auto;
                cursor: pointer;
            }
        }

</style>
